export default __webpack_public_path__ + "static/media/vehicle-FRidge-withMacro.99ee4640.xlsm";